import React from "react";
import imgAboutUs from "../../assets/home/aboutUs/imagen.png";
// import imgAboutModal from "../../assets/inicio/about-us/quienes somos - emergente.png";
import { useVisibility } from "../../hooks/useVisibility";
import "./HomeAboutUs.css";

const HomeAboutUs = ( { showModal } ) => {
  const sectionRef = useVisibility();
  const circle1Ref = useVisibility();
  const circle2Ref = useVisibility();
  const circle3Ref = useVisibility();
  const textRef = useVisibility();
  const imgRef = useVisibility();

  return (
    <div className="homeAboutUs mt-5 mb-3" id="homeAboutUs" ref={sectionRef}>
      <div className="body-about row g-2">
        <div className="cont-about-img col-md" ref={imgRef}>
          <div className="cont-img">
            <img src={imgAboutUs} alt="img about us" />
          </div>
        </div>
        <div className="cont-about-text col-md">
          <div className="about-circle-1" ref={circle1Ref}></div>
          <div className="about-circle-2" ref={circle2Ref}></div>
          <div className="about-circle-3" ref={circle3Ref}></div>
          <div className="about-context-text" ref={textRef}>
            <h3><b>QUIENES SOMOS</b></h3>
            <p>
              Somos un grupo económico con un alto sentido de Responsabilidad Social, empresarial, que busca ser su ALIADO ESTRATEGICO frente a la determinación de las perspectivas estratégicas de seguridad integral que necesita su empresa.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export { HomeAboutUs };